module.exports = __webpack_public_path__ + "static/media/2DGACM8.e887e66f.jpg";